import { PluginBuilder, TeiaViewer } from '@stereograph/teiaviewer';
import { setupPluginsTranslation } from '@translation';
import { SaveTeiaObjectsSelection, ShowTeiaSelectionRecordWidget } from './ToolbarItems';
import { TeiaSelectionRecordWidget } from './widgets/TeiaSelectionRecordWidget';

declare global {
  interface ViewerPluginRegistry {
    selectionInfo: TeiaSelectionInfoPlugin;
  }
}

const PluginBaseClass = PluginBuilder.NewPlugin('SelectionInfo');

/**
 * SelectionInfoPlugin is dependant from QTOPlugin as it uses the exported toolbar items
 */
export class TeiaSelectionInfoPlugin extends PluginBaseClass<TeiaViewer> {
  static override readonly ToolbarItems = {
    SaveTeiaObjectsSelection,
    ShowTeiaSelectionRecordWidget,
  };

  override dependencies() {
    return ['qto', 'openData', 'patchData'] as const;
  }

  override onRegister(): void {
    setupPluginsTranslation();
    this._setupWidgets();
  }

  private _setupWidgets() {
    this.viewer.widgetFactory.registerWidget('TeiaSelectionRecord', ({ viewportRect, ...rest }) => {
      const { width, height } = viewportRect;

      return new TeiaSelectionRecordWidget(this.viewer, {
        x: 5,
        y: 5,
        width: width / 3,
        height: height - 10,
        minWidth: 400,
        minHeight: 400,
        ...rest,
      });
    });
  }
}
